import { render, staticRenderFns } from "./digitalSource.vue?vue&type=template&id=5ffaa562&scoped=true&"
import script from "./digitalSource.vue?vue&type=script&lang=js&"
export * from "./digitalSource.vue?vue&type=script&lang=js&"
import style0 from "./digitalSource.vue?vue&type=style&index=0&id=5ffaa562&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffaa562",
  null
  
)

export default component.exports